@if (vm$ | async; as vm) {
  <rask-row>
    @if (vm.isGetVolymButtonVisible) {
      <rask-button
        class="p-0 my-auto"
        color="secondary"
        (click)="onGetVolymButtonClick()">
        Hämta volym från förkalkyl
      </rask-button>
    }
  </rask-row>
  <form [formGroup]="form" class="mt-1">
    <table class="simple-table">
      <thead>
        <tr>
          <th>Handelssortiment</th>
          <th>Måttslag</th>
          <th>Kvantitet</th>
        </tr>
      </thead>
      <tbody>
        <ng-container formArrayName="volymer">
          @for (volym of volymer.controls; track volym) {
            <tr
              rask-atgard-volym-row
              [volymForm]="volym">
            </tr>
          }
        </ng-container>
      </tbody>
    </table>
  </form>
}